import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CoursePreviewRefreshService {
  private refreshSubject = new Subject<{ courseId: string | number; source?: string }>();

  onRefresh$(): Observable<{ courseId: string | number; source?: string }> {
    return this.refreshSubject.asObservable();
  }

  trigger(courseId: string | number, source?: string): void {
    if (!courseId) return;
    this.refreshSubject.next({ courseId, source });
  }
}
